import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AdminDecisionModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title, 
  actionLabel, 
  variant = 'primary',
  message 
}) => {
  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    onConfirm(reason);
    setReason('');
    onHide();
  };

  const handleCancel = () => {
    setReason('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && (
          <p className="mb-3">{message}</p>
        )}
        <Form.Group>
          <Form.Label>Reason/Note (Optional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Provide a reason or note for this decision. This will be included in the customer's email notification."
          />
          <Form.Text className="text-muted">
            This note will be sent to the customer in their notification email.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant={variant} onClick={handleSubmit}>
          {actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminDecisionModal;
